// http://vuex.vuejs.org/en/getters.html
import { isEmpty } from 'lodash'

// if has token, we assume that user is logged in our system
export const hasAuthToken = ({ token }) => !isEmpty(token)

export const getAuthToken = ({token}) => token;

// get current user data
export const currentUser = ({ user }) => user

export const getUsername = ({user}) => user ? (user.username) : undefined

